import { useIntl } from 'react-intl';
import { forwardRef } from '@chakra-ui/react';

import { Table } from '../../Table';
import { type RowProps } from '../../Table/parts';
import { useFees } from '../context';

export type WithdrawalNonEuroProps = RowProps;

export const WithdrawalNonEuro = forwardRef<WithdrawalNonEuroProps, 'div'>(
  (props, ref) => {
    const intl = useIntl();
    const { fees, toFixed, toVariable } = useFees();

    const locales = {
      label: intl.formatMessage({
        id: 'subscription.fees_modal.withdrawal_non_euro.label',
      }),
      value: intl.formatMessage(
        {
          id: 'subscription.fees_modal.withdrawal_non_euro.value',
        },
        {
          fixed: toFixed(fees.additionalWithdrawalNonEuro),
          variable: toVariable(fees.additionalWithdrawalNonEuro),
        },
      ),
    };

    return (
      <Table.Row {...props} ref={ref}>
        <Table.CellText>{locales.label}</Table.CellText>
        <Table.CellAmount>{locales.value}</Table.CellAmount>
      </Table.Row>
    );
  },
);
